import { ArrowLeft } from 'lucide-react';
import { useState } from 'react';
import { RadioListItem } from './RadioListItem';
import { FormButton } from './FormButton';

interface CurrencyScreenProps {
  onBack: () => void;
  onSave: (currency: string) => void;
  currentCurrency?: string;
}

export const CurrencyScreen = ({
  onBack,
  onSave,
  currentCurrency = 'MXN',
}: CurrencyScreenProps) => {
  const [selected, setSelected] = useState(currentCurrency);
  const [loading, setLoading] = useState(false);

  const currencies = [
    { value: 'MXN', label: 'MXN', description: 'Peso mexicano' },
    { value: 'USD', label: 'USD', description: 'Dólar estadounidense' },
    { value: 'EUR', label: 'EUR', description: 'Euro' },
  ];

  const handleSave = () => {
    setLoading(true);
    // Simulate API call
    setTimeout(() => {
      setLoading(false);
      onSave(selected);
      onBack();
    }, 1000);
  };

  return (
    <div className="min-h-screen bg-[#F7F8FA]">
      {/* Header */}
      <div className="bg-white border-b border-[#E5E7EB] sticky top-0 z-10">
        <div className="flex items-center gap-3 p-4">
          <button
            onClick={onBack}
            className="w-10 h-10 flex items-center justify-center rounded-full hover:bg-[#F7F8FA] transition-colors"
          >
            <ArrowLeft className="w-6 h-6 text-[#111827]" />
          </button>
          <h1 className="text-lg font-bold text-[#111827]">Moneda</h1>
        </div>
      </div>

      {/* Content */}
      <div className="p-4 space-y-4">
        <div className="bg-white rounded-[16px] border border-[#E5E7EB] overflow-hidden divide-y divide-[#E5E7EB]">
          {currencies.map((currency) => (
            <RadioListItem
              key={currency.value}
              title={`${currency.label} (${currency.description})`}
              selected={selected === currency.value}
              onClick={() => setSelected(currency.value)}
            />
          ))}
        </div>

        <div className="bg-[#FFF4ED] rounded-[12px] p-3 border border-[#FFE4D6]">
          <p className="text-xs text-[#6B7280] text-center">
            Los precios pueden variar según el tipo de cambio
          </p>
        </div>

        <FormButton
          onClick={handleSave}
          loading={loading}
        >
          Guardar
        </FormButton>
      </div>
    </div>
  );
};
